import { useReports } from "@sail/observability";
import { useCallback, useEffect, useState } from "react";
import cookie from "../../internal/cookie/cookie";
import useDataConfig from "../useDataConfig";
/**
 * @see https://sail.stripe.me/data/api/useCookie
 */ export default function useCookie(name) {
    const dataConfig = useDataConfig();
    const reports = useReports();
    const [cookieValue, setCookieValue] = useState(()=>cookie.get(dataConfig.browserStorage, name, reports));
    const setCookie = useCallback((value, options)=>cookie.set(dataConfig.browserStorage, name, value, reports, options), [
        dataConfig.browserStorage,
        name,
        reports
    ]);
    useEffect(()=>{
        function onChange() {
            setCookieValue(cookie.get(dataConfig.browserStorage, name, reports));
        }
        cookie.subscribe(dataConfig.browserStorage, onChange, reports);
        return ()=>{
            cookie.unsubscribe(dataConfig.browserStorage, onChange, reports);
        };
    }, [
        dataConfig.browserStorage,
        name,
        reports
    ]);
    return [
        cookieValue,
        setCookie
    ];
}

//# sourceMappingURL=useCookie.js.map